module.exports = __webpack_public_path__ + "components/country-flag/static/ea-6eafa9c5d38a910e7ce07c9641fa158c.svg";